import React from "react";
import PropTypes from "prop-types";
import { getValueFormatter, getMinMaxRange } from "../utils/formatting";
import { getScrollbarWidth } from "../utils/dom";
import { defaultActions } from "../utils/visualization";
import { startCase, get } from "lodash-es";
import { Message, ChartContainer as DefaultChartContainer, } from "../components";
import { exportToCsv } from "../utils/exporters";
const scrollbarWidth = getScrollbarWidth();
export const Table = ({ title, titleAlign, valueFormatter, chartContainer: ChartContainer = DefaultChartContainer, exportFilename = "export.csv", status = { success: true }, data = [], valueFieldName = "Value", labelFieldName = "Name", labelField = "key", valueField = "value", height = 400, labelFormatter = (label) => {
    return startCase(label.toString().toLowerCase());
}, rowFormatter = (item, label, value) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("td", null, label),
        React.createElement("td", null, value)));
}, enabledControls = ["actions"], }) => {
    const noData = !data || !data.length;
    function handleAction(action) {
        if (action === "export-data") {
            exportToCsv([valueFieldName, valueFieldName], data.map((row) => [get(row, labelField), row[valueField]]), exportFilename);
        }
    }
    const _valueFormatter = valueFormatter || getValueFormatter(getMinMaxRange(data, valueField));
    return (React.createElement(ChartContainer, { title: title, titleAlign: titleAlign, height: height, actions: defaultActions, onActionChange: handleAction, enabledControls: enabledControls },
        status.success && noData && (React.createElement(Message, null, "No data available for this time period")),
        status.loading && React.createElement(Message, null, "Loading..."),
        status.error && React.createElement(Message, { error: true }, status.error.message),
        React.createElement("table", { className: "tnic-table" },
            React.createElement("thead", null,
                React.createElement("tr", { style: { paddingRight: `${scrollbarWidth}px` } },
                    React.createElement("th", null, labelFieldName),
                    React.createElement("th", null, valueFieldName))),
            React.createElement("tbody", { style: { maxHeight: `${height - 80}px` } }, data.map((item) => {
                return (React.createElement("tr", { key: item[labelField] }, rowFormatter(item, labelFormatter(get(item, labelField)), _valueFormatter(get(item, valueField)))));
            })))));
};
Table.propTypes = {
    status: PropTypes.object,
    data: PropTypes.array,
    chartContainer: PropTypes.elementType,
    title: PropTypes.node,
    labelFormatter: PropTypes.func,
    valueFormatter: PropTypes.func,
    valueField: PropTypes.string,
    labelField: PropTypes.string,
    valueFieldName: PropTypes.string,
    labelFieldName: PropTypes.string,
    enabledControls: PropTypes.arrayOf(PropTypes.oneOf(["actions"])),
    exportFilename: PropTypes.string,
};
//# sourceMappingURL=Table.js.map